import { render } from "./downloadIcon.svg?vue&type=template&id=483fe33a"
const script = {}
script.render = render

export default script